import { Box, Flex } from '@chakra-ui/layout';
import { Button, Switch, Text } from '@chakra-ui/react';
import firebase from 'firebase';
import React, { useEffect, useRef, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { ArrowLeft } from 'react-feather';
import { Redirect, useHistory, useParams } from 'react-router';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { GuardedPage } from '../guard-pages/GuardedPage';
import { LoadingPage } from '../util-pages/LoadingPage';
import { useJitsi } from './useJitsi';

const CourseLoading = () => {
  const [mottoIndex, setMottoIndex] = useState(0);
  const mottos = [
    '',
    'Wir bereiten alles vor...',
    'Wärme dich schonmal auf...',
    'Gleich gehts los...',
  ];

  const index = useRef(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (index.current < mottos.length) {
        index.current += 1;
      } else {
        index.current = 1;
      }
      setMottoIndex(index.current);
    }, 2500);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <LoadingPage>
      <Text mt={4}>{mottos[mottoIndex]}</Text>
    </LoadingPage>
  );
};

interface JitsiCoursePageProps {
  type: 'public' | 'private';
}

export const JitsiCoursePage: React.FC<JitsiCoursePageProps> = ({ type }) => {
  const { id, roomTitle } = useParams<{ id: string; roomTitle?: string }>();
  const decodedRoomTitle = roomTitle
    ? decodeURIComponent(roomTitle)
    : 'Virtueller Kursraum';

  const history = useHistory();
  const currentUser = useCurrentUser();
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [redirectUrl] = useState(
    `/login/${history.location.pathname.substring(1).split('/').join('_SLASH')}`
  );
  useDocumentTitle(decodedRoomTitle);
  const height = use100vh();
  const realHeight = height ? `calc(${height}px - 40px)` : 'calc(100vh - 40px)';

  const { loading, jitsi } = useJitsi(id, ref, decodedRoomTitle);

  useEffect(() => {
    let count = 0;
    const interval = setInterval(() => {
      count += 1;
    }, 60000);

    return () => {
      jitsi && jitsi.dispose();
      clearInterval(interval);
      if (currentUser) {
        firebase
          .firestore()
          .collection('users')
          .doc(currentUser.uid)
          .update({
            courseMinutes: firebase.firestore.FieldValue.increment(count),
            courseCount: firebase.firestore.FieldValue.increment(
              count > 1 ? 1 : 0
            ),
          });
      }
    };
  }, []);

  if (!currentUser) return <Redirect to={redirectUrl} />;

  return (
    <GuardedPage withHeader={true}>
      <Flex
        h="40px"
        w="full"
        justifyContent="space-between"
        align="center"
        px={3}
      >
        <Button
          variant="link"
          onClick={() => history.push('/')}
          colorScheme="brand"
          leftIcon={<ArrowLeft />}
          justifySelf="flex-start"
        >
          Zurück
        </Button>
        <Flex align="center">
          <Text mr={1}>Seitenleiste</Text>
          <Switch
            defaultChecked={true}
            onChange={(e) => jitsi?.executeCommand('toggleFilmStrip')}
          />
        </Flex>
      </Flex>
      <Box h={realHeight} ref={(newRef) => setRef(newRef)}>
        {loading && <CourseLoading />}
      </Box>
    </GuardedPage>
  );
};
